import { useContext, useEffect, useRef, useState } from "react";
import { getChildrensOfLv1 } from "../../api/nivel1";
import { COLOR_BOTONES, NAVBARS, PRINCIPAL } from "../../constants/colors";
import DictionaryText from "../dictionaryText/DictionaryText";

import Swal from 'sweetalert2';

import activoContext from '../../context/activoContex/activoContex.js';
import nivel1Context from '../../context/nivel1Context/nivel1Context.js'
import nivel3Context from '../../context/nivel3Context/nivel3Context.js'
import nivel4Context from '../../context/nivel4Context/nivel4Context.js'
import nivel5Context from '../../context/nivel5Context/nivel5Context.js'

import './FormDuplicateLevels.css';
import nivel2Context from "../../context/nivel2Context/nivel2Context.js";
import authContext from "../../context/authentication/authContex.js";
import { createEstructuraLectura, createEstructuraLogsFServ, createEstructuraLogsUbicaciones } from "../../utils/estructuras.js";

const FormDuplicateLevels = ({setModalToShow, data}) => {

    const {activoList, agregarActivo} = useContext(activoContext);
    const {agregarNivel1, eliminarNivel1eHijos} = useContext(nivel1Context);
    const {agregarNivel2} = useContext(nivel2Context);
    const {agregarNivel3} = useContext(nivel3Context);
    const {agregarNivel4} = useContext(nivel4Context);
    const {agregarNivel5} = useContext(nivel5Context);
    const {usuario, getValorActualFromDictionary} = useContext(authContext);

    const [saveButtonPresed,setSaveButtonPresed] = useState(false);

    const [sufijo,setSufijo] = useState('');
    const [showGuardarBtn,setShowGuardarBtn] = useState(false);
    const [previsualizationData, setPrevisualizationData] = useState(null);

    const getLevelsByIdAndLevel = async () => {
        let res = await getChildrensOfLv1(data.id); //Resta obtener niveles 4 y 5 como childrens.
        let dataToUse = res?.data?.data;

        let lv1Modelados = [];
        let lv2Modelados = [];
        let lv3Modelados = [];
        let lv4Modelados = [];
        let lv5Modelados = [];

        const addSufijo = (activoListToMap) => {
            return activoListToMap.map(a => ({...a, codActivo: `${a.codActivo}_${sufijo}`, name: `${a.name}_${sufijo}`}));
        }

        if(dataToUse){
            let activosLv1 = addSufijo(activoList.filter(a => !a.activoNivel2ID && a.activoNivel1ID == data.id))
            lv1Modelados.push({originalID: dataToUse._id, name: `${dataToUse.name}_${sufijo}`, descrp: `${dataToUse.descrp}_${sufijo}`, codigo: `${dataToUse.codNivel1}_${sufijo}`, ...((activosLv1 && activosLv1.length > 0) && {activos: activosLv1})});
            
            for(const lv of dataToUse.childrens){ //Por cada hijo del nivel sobre el que estamos parados, itera.
                switch(data.type){
                    case 'Nivel1':
                        let activosLv2 = addSufijo(activoList.filter(a => !a.activoNivel3ID && a.activoNivel2ID == lv._id));
                        lv2Modelados.push({lv1ID: dataToUse._id, originalID: lv._id, name: `${lv.name}_${sufijo}`, descrp: `${lv.descrp},_${sufijo}`, codigo: `${lv.codNivel2}_${sufijo}`, ...((activosLv2 && activosLv2.length > 0) && {activos: activosLv2})})

                        if(lv.childrens){ //Si el hijo del nivel original posee algun hijo, itera.
                            for(const lv2 of lv.childrens){
                                let activosLv3 = addSufijo(activoList.filter(a => !a.activoNivel4ID && a.activoNivel3ID == lv2._id));
                                lv3Modelados.push({lv2ID: lv._id, originalID: lv2._id, name: `${lv2.descrp}_${sufijo}`, descrp: `${lv2.descrp}_${sufijo}`, codigo: `${lv2.codNivel3}_${sufijo}`, ...((activosLv3 && activosLv3.length > 0) && {activos: activosLv3})})

                                if(lv2.childrens){
                                    for(const lv3 of lv2.childrens){
                                        let activosLv4 = addSufijo(activoList.filter(a => !a.activoNivel5ID && a.activoNivel4ID == lv3._id));
                                        lv4Modelados.push({lv3ID: lv2._id, originalID: lv3._id, name: `${lv3.name}_${sufijo}`, descrp: `${lv3.descrp},_${sufijo}`, codigo: `${lv3.codNivel4}_${sufijo}`, ...((activosLv4 && activosLv4.length > 0) && {activos: activosLv4})})

                                        if(lv3.childrens){
                                            for(const lv4 of lv3.childrens){
                                                let activosLv5 = addSufijo(activoList.filter(a => a.activoNivel5ID == lv4._id));
                                                lv5Modelados.push({lv4ID: lv3._id, originalID: lv4._id, name: `${lv4.name}_${sufijo}`, descrp: `${lv4.descrp},_${sufijo}`, codigo: `${lv4.codNivel5}_${sufijo}`, ...((activosLv5 && activosLv5.length > 0) && {activos: activosLv5})})
                                            }//Hijos de nivel 4
                                        }
                                    }//Hijos de nivel 3
                                }                                   
                            }//Hijos de nivel 2
                        }
                    break;
                }//Hijos de nivel 1
            }

            setPrevisualizationData({lv1Modelados, ...(lv2Modelados.length > 0 && {lv2Modelados}), ...(lv3Modelados.length > 0 && {lv3Modelados}), ...(lv4Modelados.length > 0 && {lv4Modelados}), ...(lv5Modelados.length > 0 && {lv5Modelados})});

            setShowGuardarBtn(true);
        }else{
            setModalToShow(null);
            Swal.fire({
                title:"Ops!",
                icon:'error'
            })
        }
    }

    const handleChangeLevelsInfo = (e, lvNro, lvIndex) => {
        setPrevisualizationData(prevData => {
            let newData = {...prevData};
            switch(lvNro){
                case 1:
                    newData.lv1Modelados[lvIndex][e.target.name] = e.target.value;
                    break;
                case 2:
                    newData.lv2Modelados[lvIndex][e.target.name] = e.target.value;                        
                    break;
                case 3:
                    newData.lv3Modelados[lvIndex][e.target.name] = e.target.value;
                    break;
                case 4:
                    newData.lv4Modelados[lvIndex][e.target.name] = e.target.value;
                    break;
                case 5:
                    newData.lv5Modelados[lvIndex][e.target.name] = e.target.value;
                    break;
            }
            return newData;
        })
    }

    const handleChangeActivosInfo = (e, lvNro, activoId, lvIndex) => {
        setPrevisualizationData(prevData => {
            let newData = {...prevData};
            switch(lvNro){
                case 1:
                    for(const act of newData.lv1Modelados[lvIndex].activos){
                        if(act._id == activoId) act[e.target.name] = e.target.value;
                    }
                    break;
                case 2:
                    for(const act of newData.lv2Modelados[lvIndex].activos){
                        if(act._id == activoId) act[e.target.name] = e.target.value;
                    }
                    break;
                case 3:
                    for(const act of newData.lv3Modelados[lvIndex].activos){
                        if(act._id == activoId) act[e.target.name] = e.target.value;
                    }
                    break;
                case 4:
                    for(const act of newData.lv4Modelados[lvIndex].activos){
                        if(act._id == activoId) act[e.target.name] = e.target.value;
                    }
                    break;
                case 5:
                    for(const act of newData.lv5Modelados[lvIndex].activos){
                        if(act._id == activoId) act[e.target.name] = e.target.value;
                    }
                    break;
            }
            return newData;
        })
    }

    const modelateActivoAndSave = async (act, lv1Saved, lv2Saved = null, lv3Saved = null, lv4Saved = null, lv5Saved = null) => {
        try {            
            const userForLecturaToDestructure = { comUserID: usuario._id, label: usuario.userName }
            const userForDispoToDestructure = { comUserID: usuario._id, value: usuario.userName }
            const userForUbicacionToDestructure = { comUserID: usuario._id, userName: usuario.userName }

            let actToSave = {
                ...act,
                DEFAULTUNIMED: act.DEFAULTUNIMED.value,
                nivel1:{codNivel1: lv1Saved.codNivel1, id: lv1Saved._id},
                ...(lv2Saved ? {nivel2:{codNivel2: lv2Saved.codNivel2, id: lv2Saved._id}} : {}),
                ...(lv3Saved ? {nivel3:{nameNivel3: lv3Saved.nameNivel3, id: lv3Saved._id}} : {}),
                ...(lv4Saved ? {nivel4:{codNivel4: lv4Saved.codNivel4, id: lv4Saved._id}} : {}),
                ...(lv5Saved ? {nivel5:{codNivel5: lv5Saved.codNivel5, id: lv5Saved._id}} : {}),

                activoType:{nameTypeActivo: act.nameTypeActivo, id:act.tipoActivoID},
                user:{...userForLecturaToDestructure},
                logsFServ: [{...createEstructuraLogsFServ(), evento:{value:'DISPO', label:'Disponible'}, user:{...userForDispoToDestructure}}],
                lecturas: [{...createEstructuraLectura(), user:{...userForLecturaToDestructure}, uniMed: {...act.DEFAULTUNIMED}, valor: 0}],
                logsUbicaciones: [
                    {
                        ...createEstructuraLogsUbicaciones(), 
                        nivel1: {codNivel1: lv1Saved.codNivel1, id:lv1Saved._id}, 
                        ...(lv2Saved ? {nivel2:{codNivel2: lv2Saved.codNivel2, id: lv2Saved._id}} : {}),
                        ...(lv3Saved ? {nivel3:{value: lv3Saved.codNivel3, id: lv3Saved._id}} : {}),
                        ...(lv4Saved ? {nivel4:{codNivel4: lv4Saved.codNivel4, id: lv4Saved._id}} : {}),
                        ...(lv5Saved ? {nivel5:{codNivel5: lv5Saved.codNivel5, id: lv5Saved._id}} : {}),
                        user: {...userForUbicacionToDestructure}
                    }
                ],
            };
            
            let activoSaved = await agregarActivo(actToSave,[]);
            return activoSaved
        } catch (error) {
            console.log("error en modelateActivoAndSave en FormDuplicateLevels");
            console.log(error);
            
        }
    }

    const handleSave = async () => {
        try {
            if(saveButtonPresed) return;
            
            Swal.fire({
                title:`Duplicando ${data.lvClicked}...`,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            setSaveButtonPresed(true);
            

            let lv1Modelados = previsualizationData.lv1Modelados;
            let lv2Modelados = previsualizationData.lv2Modelados;
            let lv3Modelados = previsualizationData.lv3Modelados;
            let lv4Modelados = previsualizationData.lv4Modelados;
            let lv5Modelados = previsualizationData.lv5Modelados;

            /*
                Se puede agregar un boolean para omitir el modelado y guardado del Nivel 1 si por ejemplo se eligiera duplicar el Nivel 2 y asi lo mismo para abajo.
                Sin embargo al If siempre accedera debido a que desde el Backend siempre van a recuperarse todos los niveles de la rama hija en el arbol.
            */
            if(lv1Modelados){ 
                for(const lv1 of lv1Modelados){

                    const lv1ToSave = {
                        codNivel1: lv1.codigo,
                        name: lv1.name,
                        descrp: lv1.name
                    }
                    let {lv1Saved,msg} = await agregarNivel1(lv1ToSave);
                    if(!lv1Saved){
                        throw new Error(`Error al guardar ${getValorActualFromDictionary('Nivel 1')}: ${lv1ToSave.name} <br/> ${msg}`);
                    } 
                   
                    let activosLv1Modelados = lv1.activos;
                    if(activosLv1Modelados){
                        for(const act of activosLv1Modelados){
                            await modelateActivoAndSave(act, lv1Saved);
                        }
                    }

                    let lv2Filtered = lv2Modelados?.filter(lv2 => lv2.lv1ID == lv1.originalID);
                    if(lv2Filtered){
                        for(const lv2 of lv2Filtered){

                            const lv2ToSave = {
                                codNivel2: lv2.codigo,
                                name: lv2.name,
                                descrp: lv2.name,
                                nivel2Nivel1: {_id: lv1Saved._id},
                                codNivel1: lv1Saved.codNivel1
                            }
                            let {lv2Saved,msg} = await agregarNivel2(lv2ToSave);
                            if(!lv2Saved){
                                await eliminarNivel1eHijos(lv1Saved._id, true)
                                throw new Error(`Error al guardar ${getValorActualFromDictionary('Nivel 2')}: ${lv2ToSave.name} <br/> ${msg}`);
                            } 

                            let activosLv2Modelados = lv2.activos;
                            if(activosLv2Modelados){
                                for(const act of activosLv2Modelados){
                                    await modelateActivoAndSave(act, lv1Saved, lv2Saved);
                                }
                            }

                            let lv3Filtered = lv3Modelados?.filter(lv3 => lv3.lv2ID == lv2.originalID);
                            if(lv3Filtered){
                                for(const lv3 of lv3Filtered){

                                    const lv3ToSave = {
                                        codNivel3: lv3.codigo,
                                        name: lv3.name,
                                        descrp: lv3.name,
                                        nivel2Nivel3: {_id: lv2Saved._id, codNivel2: lv2Saved.codNivel2},
                                    }
                                    let {lv3Saved, msg} = await agregarNivel3(lv3ToSave);
                                    if(!lv3Saved){
                                        await eliminarNivel1eHijos(lv1Saved._id, true)
                                        throw new Error(`Error al guardar ${getValorActualFromDictionary('Nivel 3')}: ${lv3ToSave.name} <br/> ${msg}`);
                                    } 
                                    
                                    let activosLv3Modelados = lv3.activos;
                                    if(activosLv3Modelados){
                                        for(const act of activosLv3Modelados){
                                            await modelateActivoAndSave(act, lv1Saved, lv2Saved, lv3Saved);
                                        }
                                    }

                                    let lv4Filtered = lv4Modelados?.filter(lv4 => lv4.lv3ID == lv3.originalID)
                                    if(lv4Filtered){
                                        for(const lv4 of lv4Filtered){

                                            const lv4ToSave = {
                                                codNivel4: lv4.codigo,
                                                name: lv4.name,
                                                descrp: lv4.name,
                                                nivel4Nivel3: {_id: lv3Saved._id, codNivel3: lv3Saved.codNivel3},
                                            }

                                            let {lv4Saved, msg} = await agregarNivel4(lv4ToSave);
                                            if(!lv4Saved){
                                                await eliminarNivel1eHijos(lv1Saved._id, true)
                                                throw new Error(`Error al guardar ${getValorActualFromDictionary('Nivel 4')}: ${lv4ToSave.name} <br/> ${msg}`);
                                            } 
                                   

                                            let activosLv4Modelados = lv4.activos;
                                            if(activosLv4Modelados){
                                                for(const act of activosLv4Modelados){
                                                    await modelateActivoAndSave(act, lv1Saved, lv2Saved, lv3Saved, lv4Saved);
                                                }
                                            }

                                            let lv5Filtered = lv5Modelados?.filter(lv5 => lv5.lv4ID == lv4.originalID);
                                            if(lv5Filtered){
                                                for(const lv5 of lv5Filtered){
                                                    
                                                    const lv5ToSave = {
                                                        codNivel5: lv5.codigo,
                                                        name: lv5.name,
                                                        descrp: lv5.name,
                                                        nivel5Nivel4: {_id: lv4Saved._id, codNivel4: lv4Saved.codNivel4}
                                                    }

                                                    let {lv5Saved, msg} = await agregarNivel5(lv5ToSave);
                                                    if(!lv5Saved){
                                                        await eliminarNivel1eHijos(lv1Saved._id, true)
                                                        throw new Error(`Error al guardar ${getValorActualFromDictionary('Nivel 5')}: ${lv5ToSave.name} <br/> ${msg}`);
                                                    } 

                                                    let activosLv5Modelados = lv5.activos;
                                                    if(activosLv5Modelados){
                                                        for(const act of activosLv5Modelados){
                                                            await modelateActivoAndSave(act, lv1Saved, lv2Saved, lv3Saved, lv4Saved, lv5Saved);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            setModalToShow(null);
            setPrevisualizationData(null);
            Swal.fire({title:"Éxito", text:`${data.lvClicked} duplicado con Éxito!`, icon:'success'});
        } catch (error) {
            setModalToShow(null);
            console.log("error en handleSave en FormDuplicateLevels");
            console.log(error);
            Swal.fire({
                title:'Ops!',
                html:error.message,
                icon:'error'
            })
            
        }
    }
    
    return <div className='container-group-form duplicateLevel'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                Duplicar <DictionaryText text={"Nivel 1"}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Parte de: </div>
                <input value={data?.lvClicked ?? ''} disabled style={{backgroundColor: "rgb(237, 237, 237)"}} className='label-form-group-data' placeholder={"nombreADuplicar"}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Sufijo: </div>
                <input disabled={showGuardarBtn} value={sufijo} onChange={(e)=>setSufijo(e.target.value)} className='label-form-group-data' maxLength={3}/>
            </div>

            <div className={`${!previsualizationData?.lv1Modelados ? 'inactive' : ''} previsualizationDataContainer`}>
                <h4><DictionaryText text={"Nivel 1"}/></h4>
                {
                    (previsualizationData && previsualizationData?.lv1Modelados) && previsualizationData?.lv1Modelados.map((lv,i) => <div className="lvModeladosContainer lv1ModeladosContainer" style={{...(i > 0 && {marginTop:'2rem'})}}>
                        <div className="lvInputs">
                            <input value={lv.codigo} name="codigo" onChange={(e)=>handleChangeLevelsInfo(e, 1, i)}/>
                            <input value={lv.name} name="name" onChange={(e)=>handleChangeLevelsInfo(e, 1, i)}/>
                        </div>
                        <div className={`${!lv?.activos ? 'inactive' : ''} activosInputsContainer`}>
                            <h6>Activos</h6>
                            {lv?.activos && lv.activos.map((a,iA) => <div className="activoInputs" style={{...(iA > 0 && {marginTop:'0.5rem'})}}>
                                <input value={a.codActivo} name="codActivo" onChange={(e)=>handleChangeActivosInfo(e, 1, a._id, i)}/>
                                <input value={a.name} name="name" onChange={(e)=>handleChangeActivosInfo(e, 1, a._id, i)}/>
                            </div>)}
                        </div>
                    </div>)
                }
            </div>
            <div className={`${!previsualizationData?.lv2Modelados ? 'inactive' : ''} previsualizationDataContainer`}>
                <h4><DictionaryText text={"Nivel 2"}/></h4>
            {
                (previsualizationData && previsualizationData?.lv2Modelados) && previsualizationData?.lv2Modelados.map((lv,i) => <div className="lvModeladosContainer lv2ModeladosContainer" style={{...(i > 0 && {marginTop:'2rem'})}}>
                    <div className="lvInputs">
                        <input value={lv.codigo} name="codigo" onChange={(e)=>handleChangeLevelsInfo(e, 2, i)}/>
                        <input value={lv.name} name="name" onChange={(e)=>handleChangeLevelsInfo(e, 2, i)}/>
                    </div>
                    <div className={`${!lv?.activos ? 'inactive' : ''} activosInputsContainer`}>
                        <h6>Activos</h6>
                        {lv?.activos && lv.activos.map((a,iA) => <div className="activoInputs" style={{...(iA > 0 && {marginTop:'0.5rem'})}}>
                            <input value={a.codActivo} name="codActivo" onChange={(e)=>handleChangeActivosInfo(e, 2, a._id, i)}/>
                            <input value={a.name} name="name" onChange={(e)=>handleChangeActivosInfo(e, 2, a._id, i)}/>
                        </div>)}
                    </div>
                </div>)
            }
            </div>
            <div className={`${!previsualizationData?.lv3Modelados ? 'inactive' : ''} previsualizationDataContainer`}>
                <h4><DictionaryText text={"Nivel 3"}/></h4>                
                {
                    (previsualizationData && previsualizationData?.lv3Modelados) && previsualizationData?.lv3Modelados.map((lv,i) => <div className="lvModeladosContainer lv3ModeladosContainer" style={{...(i > 0 && {marginTop:'2rem'})}}>
                        <div className="lvInputs">
                            <input value={lv.codigo} name="codigo" onChange={(e)=>handleChangeLevelsInfo(e, 3, i)}/>
                            <input value={lv.name} name="name" onChange={(e)=>handleChangeLevelsInfo(e, 3, i)}/>
                        </div>
                        <div className={`${!lv?.activos ? 'inactive' : ''} activosInputsContainer`}>
                            <h6>Activos</h6>
                            {lv?.activos && lv.activos.map((a,iA) => <div className="activoInputs" style={{...(iA > 0 && {marginTop:'0.5rem'})}}>
                                <input value={a.codActivo} name="codActivo" onChange={(e)=>handleChangeActivosInfo(e, 3, a._id, i)}/>
                                <input value={a.name} name="name" onChange={(e)=>handleChangeActivosInfo(e, 3, a._id, i)}/>
                            </div>)}
                        </div>
                    </div>)
                }
            </div>
            <div className={`${!previsualizationData?.lv4Modelados ? 'inactive' : ''} previsualizationDataContainer`}>
                <h4><DictionaryText text={"Nivel 4"}/></h4>                
                {
                    (previsualizationData && previsualizationData?.lv4Modelados) && previsualizationData?.lv4Modelados.map((lv,i) => <div className="lvModeladosContainer lv4ModeladosContainer" style={{...(i > 0 && {marginTop:'2rem'})}}>
                        <div className="lvInputs">
                            <input value={lv.codigo} name="codigo" onChange={(e)=>handleChangeLevelsInfo(e, 4, i)}/>
                            <input value={lv.name} name="name" onChange={(e)=>handleChangeLevelsInfo(e, 4, i)}/>
                        </div>
                        <div className={`${!lv?.activos ? 'inactive' : ''} activosInputsContainer`}>
                            <h6>Activos</h6>
                            {lv?.activos && lv.activos.map((a,iA) => <div className="activoInputs" style={{...(iA > 0 && {marginTop:'0.5rem'})}}>
                                <input value={a.codActivo} name="codActivo" onChange={(e)=>handleChangeActivosInfo(e, 4, a._id, i)}/>
                                <input value={a.name} name="name" onChange={(e)=>handleChangeActivosInfo(e, 4, a._id, i)}/>
                            </div>)}
                        </div>
                    </div>)
                }
            </div>
            <div className={`${!previsualizationData?.lv5Modelados ? 'inactive' : ''} previsualizationDataContainer`}>
                <h4><DictionaryText text={"Nivel 5"}/></h4>                
                {
                    (previsualizationData && previsualizationData?.lv5Modelados) && previsualizationData?.lv5Modelados.map((lv,i) => <div className="lvModeladosContainer lv5ModeladosContainer" style={{...(i > 0 && {marginTop:'2rem'})}}>
                        <div className="lvInputs">
                            <input value={lv.codigo} name="codigo" onChange={(e)=>handleChangeLevelsInfo(e, 5, i)}/>
                            <input value={lv.name} name="name" onChange={(e)=>handleChangeLevelsInfo(e, 5, i)}/>
                        </div>
                        <div className={`${!lv?.activos ? 'inactive' : ''} activosInputsContainer`}>
                            <h6>Activos</h6>
                            {lv?.activos && lv.activos.map((a,iA) => <div className="activoInputs" style={{...(iA > 0 && {marginTop:'0.5rem'})}}>
                                <input value={a.codActivo} name="codActivo" onChange={(e)=>handleChangeActivosInfo(e, 5, a._id, i)}/>
                                <input value={a.name} name="name" onChange={(e)=>handleChangeActivosInfo(e, 5, a._id, i)}/>
                            </div>)}
                        </div>
                    </div>)
                }
            </div>

            <div className='container-btn-group'>
                {showGuardarBtn && <button className='btn-form-group' onClick={handleSave} style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}}>GUARDAR</button>}
                {!showGuardarBtn && <button className='btn-form-group' disabled={sufijo ? false : true} onClick={getLevelsByIdAndLevel} style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}}>GENERAR LISTA</button>}
                <button className='btn-cancel-form-group' onClick={() => setModalToShow(null)}>Cancelar</button>
            </div>
        </div>

}

export default FormDuplicateLevels;